<template>
    <div class="proposeList">
        <!-- <div class="header">
            <img src="@/assets/new/fan.png"  @click="goHome" alt="">
            <span>我的奖励</span>
        </div> -->
        <div class="oview">
            <div class="done">
                <img :src="thumbnail" class="img_nft" alt="" />
                <div class="dnview">
                    <img :src="thumbnail" class="dlogo" alt="" />
                    <span class="dname">{{ name }}</span>
                    <span class="dprice">${{ price }}</span>
                </div>
            </div>
            <div class="gaishu">
                <div class="gone">
                    <span class="gai">{{ $t("new.gaishu") }}</span>
                    <span class="lai ml">{{ $t("new.laiyuan") }}</span>
                    <img src="@/assets/c/dlogo.png" class="ndlogo" alt="" />
                    <span class="dmiao"> {{ source }}</span>
                </div>
                <div class="gtwo">
                    <div class="titem">
                        <img
                            src="@/assets/c/img_zs.png"
                            class="img_zs"
                            alt=""
                        />
                        <span class="xname">{{ $t("new.xxin") }}</span>
                    </div>
                    <div class="titem">
                        <span class="xleft">{{ $t("new.hedizhi") }}</span>
                        <div class="xrig">
                            <span class="rval">{{ contract_address }}</span>
                            <img
                                src="@/assets/c/icon_fz.png"
                                class="icon_fz"
                                alt=""
                                @click="onCopy(contract_address)"
                            />
                        </div>
                    </div>
                    <div class="titem">
                        <span class="xleft">{{ $t("new.daibiao") }}</span>
                        <div class="xrig">
                            <span class="rval">{{ contract_standard }}</span>
                        </div>
                    </div>
                    <div class="titem">
                        <span class="xleft">{{ $t("new.wang") }}</span>
                        <div class="xrig">
                            <span class="rval">{{ network }}</span>
                        </div>
                    </div>
                </div>
                <div class="gtwo">
                    <div class="titem">
                        <img
                            src="@/assets/c/img_zs.png"
                            class="img_zs"
                            alt=""
                        />
                        <span class="xname">{{ $t("new.hygzxs") }}</span>
                    </div>
                    <div
                        class="titemtwo"
                        style="word-wrap: break-word"
                        v-html="content"
                    ></div>
                    <!--                        {{ $t('new.pmiaoshu') }}-->
                </div>
            </div>
        </div>
        <div class="fanview" @click="$router.go(-1)">
            <img src="@/assets/c/fan.png" class="bg" alt="" />
        </div>
        <div class="botview">
            <div class="botone">
                <span class="bprice">${{ price }}</span>
                <div class="rgou">
                    <img src="@/assets/c/img_an.png" class="bg" alt="" />
                    <div class="gous" @click="pay">
                        {{ $t("new.gname") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { showToast, getToken } from "@/libs/util.js";
import { ajaxData } from "@/api/ajax";
import { Toast } from "vant";
import Web3 from "web3";
import yyds_Abi from "@/abi/yydsAbi";
import buyAbi from "@/abi/buyAbi";
import InvestAbi from "@/abi/Invest-abi.json";
import Erc20Abi from "@/abi/erc20Abi.js";
import { CoinContract } from "@/libs/Contract.js";
import { INVEST_ADDRESS, USDT_ADDRESS } from "@/libs/ContractAddress.js";
export default {
    data() {
        return {
            id: 0,
            name: "",
            address: "",
            network: "",
            price: "",
            source: "",
            synopsis: "",
            thumbnail: "",
            content: "",
            contract_address: "",
            contract_standard: "",
            gmc_token: "0xe9D505ca4a71AFAE9d03a82837A0BFb156a5b598",
            // gmc_token:"0xb9fF8b70A186778EbE190CA7a132Ac193E3DE177",
            // usdt_token: "0x55d398326f99059fF775485246999027B3197955",
            buy_token: "0x58625C8F01e66445c23cB242EB343583Af7a447a",
            web3Provider: null,
            web3: null,

            parent_array: {},
            usdtContract: {},
            usdtBalance: 0,
            usdtAllowance: 0,
            btnDisabled: false,
        };
    },
    created() {
        let vm = this;
        if (vm.$route.query.id != undefined) {
            vm.id = vm.$route.query.id;
        }
        if (window.ethereum) {
            vm.web3Provider = window.ethereum;
            vm.web3 = new Web3(vm.web3Provider);
        }
        vm.NftDetail();
        this.init();
    },
    methods: {
        goHome() {
            this.$router.go(-1);
        },
        onCopy(txt) {
            this.$copyText(txt)
                .then(() => {
                    showToast(this.$t("複製成功"));
                })
                .catch(() => {
                    showToast(this.$t("複製失敗"));
                });
        },
        async init() {
            this.getContract();
            await this.getUsdtBalance();
            console.log(`当前用户余额${this.usdtBalance / Math.pow(10, 18)}`);
            this.usdtAllowance = await this.getUsdtAllowance(INVEST_ADDRESS);
            this.usdtAllowance = this.usdtAllowance / Math.pow(10, 18);
            console.log("授权额度", this.usdtAllowance);
        },
        getContract() {
            this.usdtContract = new CoinContract(Erc20Abi, USDT_ADDRESS);
            console.log("usdtContract", this.usdtContract);
        },
        async getUsdtBalance() {
            this.usdtBalance = await this.usdtContract.balanceOf();
        },
        async getUsdtAllowance(address) {
            return await this.usdtContract.allowance(address);
        },
        approve(val, key) {
            if (this.btnDisabled) return;
            this.btnDisabled = true;
            Toast.loading({
                forbidClick: true,
                duration: 0,
            });
            this.usdtContract
                .approve("100000000000000000000000", INVEST_ADDRESS)
                .then((res) => {
                    this.btnDisabled = false;
                    let interval = setInterval(() => {
                        this.usdtContract
                            .getTransactionReceipt(res)
                            .then(async (res1) => {
                                console.log(`授权结果: ${res1}`);
                                if (res1 != null) {
                                    Toast.clear();
                                    this.usdtAllowance =
                                        await this.getUsdtAllowance(
                                            INVEST_ADDRESS
                                        );
                                    showToast(this.$t("授權成功"));
                                    clearInterval(interval);
                                }
                            })
                            .catch((err) => {
                                Toast.clear();
                            });
                    }, 2000);
                })
                .catch((err) => {
                    Toast.clear();
                    this.btnDisabled = false;
                });
        },
        async pay() {
          if (!getToken()) {
            showToast(this.$t("execute_connect_wallet"));
            return;
          }
            if (this.usdtAllowance <= 0) {
                this.approve();
                return;
            }
            if (this.btnDisabled) return;
            this.btnDisabled = true;
            Toast.loading({
                forbidClick: true,
                duration: 0,
            });
            // 生成订单
            let order = await this.getOrder();
            console.log(order);
            if (!order) return;
            // 支付合约
            await this.invest_contract_pay(order);
        },
        async getOrder() {
            let res = await ajaxData("/nft/buy", {
                id: this.id,
                usdt: this.price,
            }).catch((e) => (this.btnDisabled = false));
            console.log(res);
            if (res.code == 0) {
                return res.data;
            } else {
                this.btnDisabled = false;
            }
        },
        async payOk(order, payhash) {
            let res = await ajaxData("/nft/pay", {
                id: order.orderid,
                amount: order.amount,
                hash: payhash,
            }).catch((e) => (this.btnDisabled = false));
            console.log(res);
            if (res.code == 0) {
                return res.data;
            } else {
                this.btnDisabled = false;
            }
        },
        // 业务
        async invest_contract_pay(order) {
            console.log(order);
            // amount    orderid   paytype
            // let amount = order.amount * Math.pow(10, 18);
            // console.log("amount", amount);
            let amount = this.web3.utils.toWei(
                order.amount,
                "ether"
            );
            let contract = new CoinContract(InvestAbi, INVEST_ADDRESS);
            console.log("contract", contract);
            let hash = "";
            // vm.invite = "0x8708b44673088871b8A03A81Af1f999ba0e0fF1b";
            contract
                .invest(order.paytype, order.orderid, amount.toString())
                .then((res) => {
                    console.log("hash", res);
                    hash = res;
                    let interval = setInterval(() => {
                        this.usdtContract
                            .getTransactionReceipt(res)
                            .then(async (res1) => {
                                console.log(`授权结果: ${res1}`);
                                if (res1 != null) {
                                    Toast.clear();
                                    showToast(this.$t("購買成功"));
                                    await this.payOk(order, res);
                                    clearInterval(interval);
                                }
                            })
                            .catch((err) => {
                              showToast(this.$t("purchase_fail"));
                                Toast.clear();
                            });
                    }, 2000);
                })
                .catch((e) => {
                    Toast.clear();
                    this.btnDisabled = false;
                });
            return hash;
        },

        NftDetail() {
            let vm = this;
            ajaxData("/nft/info", {
                id: vm.id,
            }).then((response) => {
                let info = response.data.info;
                vm.address = response.data.address;
                console.log(vm.address);
                vm.name = info.name;
                vm.network = info.network;
                vm.price = info.price;
                vm.source = info.source;
                vm.synopsis = info.synopsis;
                vm.thumbnail = info.thumbnail;
                vm.content = info.content;
                vm.contract_address = info.contract_address;
                vm.contract_standard = info.contract_standard;
                this.parent_array = response.data.parent_array;
                console.log(response);
                if (localStorage.getItem("locale") == "en") {
                    vm.name = info.name_en;
                    vm.content = info.content_en;
                    vm.synopsis = info.synopsis_en;
                }
            });
        },
    },
};
</script>


<style scoped lang="less">
p {
    margin: 0;
    padding: 0;
}

.proposeList {
    width: 100%;
    min-height: 100vh;
    background: #f3f5f8;
    padding: 30px 0px 90px;
    .oview {
        padding: 0 15px;
    }
    .done {
        background: #ffffff;
        border-radius: 20px;
        padding: 12px;
        .img_nft {
            height: 140px;
            border-radius: 20px;
            width: 100%;
        }
        .dnview {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 15px;
            .dlogo {
                width: 22px;
                height: 22px;
                margin-right: 8px;
            }
            .dname {
                font-weight: 500;
                font-size: 16px;
                color: #1a1a1a;
            }
            .dprice {
                margin-left: auto;
                font-weight: bold;
                font-size: 18px;
                color: #1a1a1a;
            }
        }
    }
    .gaishu {
        background: #ffffff;
        border-radius: 20px;
        padding: 12px 15px;
        display: flex;
        flex-direction: column;
        margin-top: 10px;

        .gone {
            display: flex;
            flex-direction: row;
            align-items: center;
            border-bottom: 0.5px solid #eee;
            padding-bottom: 10px;
            .gai {
                font-weight: 500;
                font-size: 15px;
                color: #1a1a1a;
            }
            .ml {
                margin-left: auto;
            }
            .lai {
                font-weight: 500;
                font-size: 12px;
                color: #999999;
            }
            .ndlogo {
                width: 19px;
                height: 19px;
                margin: 0 8px;
            }
            .dmiao {
                font-weight: 500;
                font-size: 12px;
                color: #1a1a1a;
            }
        }
    }
    .gtwo {
        display: flex;
        flex-direction: column;
        margin-top: 15px;
        .titem {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 15px;
            .img_zs {
                width: 5px;
                height: 10px;
                margin-right: 3px;
            }
            .xname {
                font-weight: 500;
                font-size: 15px;
                color: #1a1a1a;
            }
            .xleft {
                font-weight: 500;
                font-size: 12px;
                color: #999999;
            }
            .xrig {
                margin-left: auto;
                display: flex;
                flex-direction: row;
                align-items: center;
                .rval {
                    font-weight: 500;
                    font-size: 12px;
                    color: #111111;
                }
                .icon_fz {
                    width: 12px;
                    height: 12px;
                    margin-left: 4px;
                }
            }
        }
        .titemtwo {
            font-weight: 500;
            font-size: 12px;
            color: #666666;
        }
    }
    .ml {
        margin-left: auto;
    }
    .botview {
        // height: 70px;
        // background: #FFFFFF;
        position: fixed;
        width: 100%;
        bottom: 25px;
        display: flex;
        flex-direction: row;
        padding: 0 30px;
        align-items: center;
        z-index: 10;
        .botone {
            background: #26e7fe;
            border-radius: 22px;
            height: 44px;
            width: 100%;
            padding: 0 0 0 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .bprice {
            font-weight: 500;
            font-size: 20px;
            color: #1a1a1a;
        }
        .rgou {
            margin-left: auto;
            width: 120px;
            height: 100%;
            position: relative;
            .gous {
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: normal;
                font-size: 16px;
                color: #f5f7f9;
            }
        }
    }
    .header {
        height: 50px;
        // margin-bottom: 12px;
        // padding: 40px 12px 0 12px;
        padding: 6px;
        box-sizing: border-box;
        background: rgba(52, 56, 75, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        position: sticky;
        width: 100%;
        z-index: 10;
        top: 0;
        img {
            width: 55px;
            height: 55px;
            position: absolute;
            left: 10px;
        }

        span {
            font-weight: bold;
            font-size: 18px;
            color: #ffffff;
        }
    }

    .mhead {
        // position: relative;
        // top: 50px;
    }
}
</style>
